// 表項目の行追加画面
import React from 'react'
import styled from 'styled-components'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import { Button, TextField } from '@material-ui/core'

import { TableRowType, TableAttribute } from '../redux/cardAttributeDbSlice';

const ItemField = styled(TextField)`
  width: 100%;
  margin-bottom: 7px;
`

type AddTableAttributeRowDialogProps = {
  open: boolean;
  onClose: () => void;
  item: TableAttribute;
  addTableRow: (row: TableRowType) => void;
  rowLength: number;
}
const AddTableAttributeRowDialog: React.FC<AddTableAttributeRowDialogProps> = ({open, onClose, item, addTableRow, rowLength}) => {
  const ids = Object.keys(item.columnNames);
  const names = ids.map(id => item.columnNames[id]);
  const row: TableRowType = { values: {}, order: rowLength };

  const addExe = () => {
    addTableRow(row);
    onClose();
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth="xs">
      <DialogTitle>表に一行追加します</DialogTitle>
      <DialogContent>
        { ids.map((id, ix) => 
          <ItemField variant="outlined" label={names[ix]} onChange={(ev) => row.values[id] = ev.currentTarget.value} />
        ) }
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="text" color="primary">
          キャンセル
        </Button>
        <Button variant="text" color="primary" onClick={addExe}>
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default AddTableAttributeRowDialog;
